import { Routes } from '@angular/router';
import { BOOKING_FIT_DOCUMENT_CONFIG } from './base/booking-fit-document-config';

export const bookingFitDocumentRoutes: Routes = [
  {
    path: BOOKING_FIT_DOCUMENT_CONFIG.routePath,
    loadComponent: () =>
      import(
        './components/smart/booking-fit-document-page/booking-fit-document-page.component'
      ).then((m) => m.BookingFitDocumentPageComponent),
  },
];
